import { Middleware } from '@reduxjs/toolkit';
import { authorsApiSlice } from 'store/api/authors-api/authors-api';
import { brandsApiSlice } from 'store/api/brands-api/brands-api';
import { couponsApiSlice } from 'store/api/coupons-api‎/coupons-api‎';
import { dataExportsApiSlice } from 'store/api/data-exports-api/data-exports-api';
import { domainsApiSlice } from 'store/api/domains-api/domains-api';
import { melApiSlice } from 'store/api/mel-api/mel-api';
import { pageStatusesApiSlice } from 'store/api/page-statuses-api/page-statuses-api';
import { pagesApiSlice } from 'store/api/pages-api/pages-api';
import { productLinksApiSlice } from 'store/api/product-links-api/product-links-api';
import { productsApiSlice } from 'store/api/products-api/products-api';
import { publishersApiSlice } from 'store/api/publishers-api/publishers-api';

export const getRtkQueryMiddlewares = (): Middleware[] => [
  authorsApiSlice.middleware,
  brandsApiSlice.middleware,
  domainsApiSlice.middleware,
  publishersApiSlice.middleware,
  pagesApiSlice.middleware,
  melApiSlice.middleware,
  productsApiSlice.middleware,
  couponsApiSlice.middleware,
  productLinksApiSlice.middleware,
  dataExportsApiSlice.middleware,
  pageStatusesApiSlice.middleware,
];
